import { Nullable } from '@/shared/types/app.types'

export enum NotificationTemplateType {
    CASE= 'CASE',
    SAMPLE = 'SAMPLE',
    APPLIED_BILLABLE_CONCEPT_AUTHORIZATION = 'APPLIED_BILLABLE_CONCEPT_AUTHORIZATION'
}

export interface customNotificationTextTemplatePatchInBatchRequest {
    active: boolean,
    id: number,
    text: string,
    title: string
}

export interface NotificationTemplateCreateRequest {
    active: boolean,
    text: string,
    title: string,
    type: Nullable<NotificationTemplateType>
}

export interface NotificationTemplateUpdateRequest {
    id: Nullable<number>,
    active: boolean,
    text: string,
    title: string
}
